import LpLogEntry from './log_entry';

/*
 * Project: LegalPlace assistant
 * File: src/app/log/log.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/


class LpLog {
  constructor() {
    this.logs = [];
  }

  log(type, message) {
    this.logs.push(new LpLogEntry(type, message));
  }
}


export default LpLog;



// WEBPACK FOOTER //
// ./src/app/log/log.js